module.exports = __webpack_public_path__ + "static/ISO14001-logo-a0abd8856ec5266d11ee2a354d6249c0.svg";